export const ROUTE_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  AGENT: '/home',
  PRICING: '/pricing',
  EDIT_AGENT: '/edit-agent',
  CREATE_AGENT: '/create-agent',
  LOGIN_LINKEDIN: '/login-linkedin',
  LOGIN_TWITTER: '/login-twitter',
  LOGIN_GOOGLE: '/login-google',
  LOGIN_MICROSOFT: '/login-microsoft',
  LOGIN_APPLE: '/login-apple',
  LOGIN_FACEBOOK: '/login-facebook',
  DATATAG: '/data-tag',
  CUSTOMER_ACCOUNTS: '/customer-accounts',
  CREATE_CUSTOMER_ACCOUNTS: '/customer-details',
  IMPORT_USER: '/import-user',
  CHATBOT_WIDGET: '/chatbot-widget',
  CHATTING: '/chatting',
  CONVERSATION_HISTORY: '/conversation-history',
  CHATBOT_SETTINGS: '/chatbot-settings',
  TNC: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  MONITOR_DASHBOARD: '/monitor-dashboard',
  CHECKOUT: '/checkout',
  PAYMENT_STATUS: '/checkout/payment-status/:status',
  ADD_NEW_STATUS: '/add-new-package/payment-status/:status',
  CHANGE_PLAN_STATUS: '/change-plan/payment-status/:status',
  OVER_VIEW: '/billing',
  PROVIDER: '/provider',
  PAYMENT_METHOD: '/payment-method',
  CHANGE_PLAN: '/change-plan',
  ADD_NEW_PACKAGE: '/add-new-package',
  RENEW_PACKAGE: '/renew-package',
  BLOG: '/:slug',
  BLOG_DETAIL: '/blog/:slug',
  NOT_FOUND: '/404',
  PLAN_INACTIVE: '/plan-inactive',
  NEWS: '/news/:slug',
  MONITOR_DASHBOARD_BOT: '/monitor-dashboard-bot',
  ROLE: '/role',
  AUTH_USER: '/auth-user',
  ONBOARDING: '/onboarding',
  CREATE_TOOL: '/create-tool',
  TOOL: '/tool',
};

export const LOCAL_STORAGE = {
  LANGUAGE: 'Evol_studio_Language',
  ACCESS_TOKEN: 'Evol_studio_ACCESS_TOKEN',
  REFRESH_TOKEN: 'Evol_studio_REFRESH_TOKEN',
  SOCIAL_PKCE_UUID: 'Evol_studio_SOCIAL_PKCE_UUID',
  SOCIAL_PKCE_STATE: 'Evol_studio_SOCIAL_PKCE_STATE',
  SOCIAL_CODE_CHALLENGE: 'Evol_studio_SOCIAL_CODE_CHALLENGE',
  REDIRECT_PATH: 'Evol_studio_REDIRECT_PATH',
};

export const LOCAL_STORAGE_CHATBOT = {
  BOTKEY: 'Evol_studio_BOTKEY',
  ACCESSTOKEN_CHATBOT: 'Evol_studio_ACCESSTOKEN_CHATBOT',
  REFRESHTOKEN_CHATBOT: 'Evol_studio_REFRESHTOKEN_CHATBOT',
  ROLE: 'Evol_studio_ROLE',
  CONVERSATION_CODE: 'Evol_studio_CONVERSATION_CODE',
  VERIFIED: 'Evol_studio_VERIFIED',
  TEST_ROLE: 'Evol_studio_TEST_ROLE',
  TEST_VERIFIED: 'Evol_studio_TEST_VERIFIED',
  AGENT_CODE: 'Agent_code',
  SESSION_DATA: 'Evol_studio_SESSION_DATA',
  MAXLIFE_SESSION: 'Evol_studio_MAXLIFE_SESSION',
};

export const SOCIAL_LOGIN_HOST = {
  GOOGLE: 'https://accounts.google.com/o/oauth2/v2/auth',
  TWITTER: 'https://twitter.com/i/oauth2/authorize',
  LINKEDIN: 'https://www.linkedin.com/oauth/v2/authorization',
  MICROSOFT: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
  FACEBOOK: 'https://www.facebook.com/v20.0/dialog/oauth',
  APPLE: 'https://appleid.apple.com/auth/authorize',
  SLACK: 'https://slack.com/oauth/v2/authorize',
  WHATSAPP: 'https://www.facebook.com/v20.0/dialog/oauth',
};

export const URL_CONST = {
  FILE_UPLOAD_CHUNK: 'api/v1/files/upload-chunk',
  FILE_MERGE_CHUNK: 'api/v1/files/merge-chunk',
};

export const MAX_SIZE_UPLOAD = 15728640; // 15MB
export const PAGE_SIZE = 10;

export const allowedExtensions = [
  'epub',
  'rtf',
  'txt',
  'csv',
  'tsv',
  'docx',
  'doc',
  'odt',
  'pdf',
  'xlsx',
  'ods',
  'pptx',
  'odp',
  'md',
  'xls',
  'ppt',
];

export const allowedExtensionsModalKnowledge = [
  'epub',
  'rtf',
  'txt',
  'docx',
  'doc',
  'odt',
  'pdf',
  'pptx',
  'odp',
  'md',
  'ppt',
  'xlsx',
  'xls',
];

export const allowedImageExtensions = ['jpg', 'png', 'jpeg'];

export const INVALID_FILES = {
  NOT_SUPPORTED_TYPE: 'NOT_SUPPORTED_TYPE',
  MAX_SIZE_UPLOAD: 'MAX_SIZE_UPLOAD',
  ERROR_UPLOAD: 'ERROR_UPLOAD',
};

export const KNOWLEDGE_STATUS = {
  TRAINED: 'trained',
  PROCESSING: 'processing',
  ERROR: 'error',
};

export const CrawLinks = [
  {
    label: 'All page',
    value: 1,
  },
  {
    label: 'Sitemap',
    value: 3,
  },
];

export const DAYOFWEEK = {
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
  SUN: 0,
};

export const TAG_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  DEFAULT: 'default',
  PRIVATE: 'private',
  PUBLIC: 'public'
};

export const AGENT_TYPE = {
  ANONYMOUS: 3,
  VERIFIED: 2,
  BOTH: 1,
};

export const STORAGE_TYPE = {
  WEBSITE: 1,
  FILE: 2,
  SHARE_POINT: 3,
  GOOGLE_DRIVE: 4,
  CONFLUENCE: 5,
  ONE_DRIVE: 6,
  PRIVATE_CLOUD: 7,
};

export const AUTHENTICATION_TYPE = {
  SINGLE_SIGN_ON: 1,
  SMS_OTP: 2,
  EMAIL_OTP: 3,
};

export const NAME_AUTHENTICATION_TYPE = {
  [AUTHENTICATION_TYPE.SINGLE_SIGN_ON]: '',
  [AUTHENTICATION_TYPE.SMS_OTP]: 'sms',
  [AUTHENTICATION_TYPE.EMAIL_OTP]: 'mail',
};

export const mediaType = [
  { name: 'File', id: 1, value: 'messageFile' },
  { name: 'Video', id: 2, value: 'messageVideo' },
  { name: 'Image', id: 3, value: 'messageImage' },
  { name: 'None above', id: 4, value: 'messageNone' },
];

export const userSendMessage = [
  { name: 'Dynamic', id: 1, value: 1 },
  { name: 'Static', id: 2, value: 2 },
];

export const channelSendMessage = [
  { name: 'Website', id: 1, value: 'website' },
  { name: 'Zalo OA', id: 2, value: 'zalooa' },
  { name: 'Zalo Bot', id: 6, value: 'zalobot' },
  { name: 'Facebook', id: 4, value: 'facebook' },
  { name: 'WhatsApp  Business', id: 5, value: 'whatsapp' },
  { name: 'None of above (Use for automation without user interaction)', id: 3, value: 'none' },
];

export const targetModeSendMessage = [
  { name: 'Create new thread', id: 1, value: 1 },
  { name: 'Persistent thread', id: 2, value: 2 },
];

export const responeType = [
  { name: 'Text', id: 1, value: 'questionText' },
  { name: 'Email', id: 2, value: 'questionEmail' },
  { name: 'Number', id: 3, value: 'questionNumber' },
  { name: 'Option', id: 4, value: 'questionOption' },
];

export const conditionType = [
  { name: 'No', id: 1, value: 'conditionNoResponse' },
  { name: 'Yes', id: 2, value: 'conditionIfAnswer' },

];

export const methods = [
  { name: 'GET', key: 'GET' },
  { name: 'POST', key: 'POST' },
  { name: 'PUT', key: 'PUT' },
  { name: 'DELETE', key: 'DELETE' },
];

export const sendMailTo = [
  { name: 'email address', id: 1, value: 'sendMailEmail', },
  { name: 'variable', id: 2, value: 'sendMailVariable' },

];

export const dataSource = [
  { name: 'Search only selected sources', id: 1, value: 'dataSource' },
  { name: 'Search within group data', id: 2, value: 'dataTag' },
  { name: 'Only use AI general knowledge', id: 3, value: 'aiGeneral' },
];

export const answerResponseType = [
  // { name: 'Query', id: 1, value: 'query' },
  { name: 'Natural language', id: 2, value: 'natural' },
];

export const generativeResponseType = [
  { name: 'Query', id: 1, value: 'query' },
  { name: 'Natural language', id: 2, value: 'natural' },
];

export const triggerType = [
  { name: 'User command', id: 1, value: 'usercommand' },
  { name: 'External', id: 2, value: 'external' },
];

export type StatusConnectType = 'connecting' | 'connected' | 'disconnected';
